import PhoneInput from 'react-phone-input-2';
import { Controller } from 'react-hook-form';
import 'react-phone-input-2/lib/bootstrap.css';

interface PhoneInputControlledProps {
  control: any;
  name: string;
  defaultCountry?: any;
  defaultValue?: string;
  handleChangeCountry?: Function;
  required?: string | boolean;
}

function PhoneInputControlled({
  control,
  name,
  defaultCountry = 'gb',
  defaultValue,
  handleChangeCountry,
  required = false
}: PhoneInputControlledProps) {
  const handleOnChange = (value: any, country: any, onChange: Function) => {
    onChange(value);
    if (handleChangeCountry) {
      handleChangeCountry(country.countryCode);
    }
  };
  return (
    <Controller
      control={control}
      rules={{ required: required }}
      // @ts-ignore
      name={name}
      render={({ field: { onChange, value } }) => (
        <PhoneInput country={defaultCountry} value={value || defaultValue} onChange={(value, country) => handleOnChange(value, country, onChange)} />
      )}
    />
  );
}

export default PhoneInputControlled;
